import React from 'react';
import VectorImage from '../vectorImage/VectorImage';

interface IIcon {
    type: JSX.Element;
    classes?: string;
}

const Icon = ({ type, classes }: IIcon): React.ReactElement => (
    <VectorImage svg={type} classes={classes} />
);

export default Icon;
